import '../../Styles/Home.css';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';
// import heroVideo from '../../Assets/Home/Hero/VN20260130_112242.mp4';
import heroVideo from '../../Assets/Home/Hero/LDD_video.mp4';
const Hero = () => {
  const textVariant = {
    hidden: { opacity: 0, y: 80 },
    visible: { opacity: 1, y: 0, transition: { duration: 1.5, ease: 'easeOut' } },
  };

  const buttonVariant = {
    hidden: { scale: 0 },
    visible: { scale: 1, transition: { duration: 0.5, ease: 'easeOut' } },
    hover: { scale: 1.1 },
  };

  return (
    <div className="relative flex items-center h-[80vh] max-lg:h-[70vh] mb-32 overflow-hidden">

      {/* 🎥 Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover -z-10"
        src={heroVideo}
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black opacity-60"></div>

      {/* Text Content */}
      <div className="relative ml-10 z-10 mt-16 flex flex-col text-white px-6">

        <motion.h3
          className="text-[#61acca] text-lg sm:text-xl md:text-2xl pb-2"
          variants={textVariant}
          initial="hidden"
          animate="visible"
        >
          We Make a Difference
        </motion.h3>

        <motion.h1
          className="text-3xl md:text-5xl font-bold mb-4"
          variants={textVariant}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
        >
          Building <span className="text-[#8364c3] md:text-6xl">Tomorrow’s</span>
          <br />
          Infrastructure, <span className="text-[#8364c3] md:text-6xl">Today</span>
        </motion.h1>

        <motion.p
          className="text-stone-200 text-base sm:text-lg leading-relaxed mb-8 max-w-xl"
          variants={textVariant}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.1 }}
        >
          A decade of trusted engineering consultancy — from design and supervision to advanced Nabl lab testing and structural health monitoring.
        </motion.p>

        <motion.div
          className="px-8 py-2 text-white bg-gradient-to-r max-w-32 from-[#61acca] to-[#8364c3] rounded-xl text-lg font-medium"
          variants={buttonVariant}
          initial="hidden"
          animate="visible"
          whileHover="hover"
        >
          <NavLink to="/Career">
            <span className="text-white">Join Us</span>
          </NavLink>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
